import React from 'react';
import { DialogProps, Dialog, DialogTitle, LargeTitle, IconButton, Theme } from '@indigo-ag/component-module';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import { createStylesHook } from 'shared/hooks/createStylesHook';

interface EnhancedDialogProps extends DialogProps {
  dialogMaxWidth?: string;
  dialogMaxHeight?: string;
  dialogMinHeight?: string;
  title?: string;
  children: React.ReactNode;
}

interface StyleProps {
  dialogMaxWidth: EnhancedDialogProps['dialogMaxWidth'];
  dialogMaxHeight: EnhancedDialogProps['dialogMaxHeight'];
  dialogMinHeight: EnhancedDialogProps['dialogMinHeight'];
}

const useStyles = createStylesHook<Theme, StyleProps>({
  alignRight: {
    marginLeft: 'auto !important'
  },
  root: props => {
    return {
      maxWidth: props.dialogMaxWidth || 480,
      maxHeight: props.dialogMaxHeight || '90%',
      minHeight: props.dialogMinHeight || 380
    };
  },
  scrollPaper: {
    alignItems: 'center'
  },
  textTransformCapitalize: {
    textTransform: 'capitalize'
  }
});

export const EnhancedDialog: React.FunctionComponent<EnhancedDialogProps> = ({
  title,
  open,
  onClose,
  children,
  dialogMaxHeight,
  dialogMaxWidth,
  dialogMinHeight,
  ...rest
}) => {
  /**
   * Styles
   */
  const classes = useStyles({ dialogMaxWidth, dialogMaxHeight, dialogMinHeight });

  const closeModal = () => {
    if (onClose) {
      onClose(false, 'escapeKeyDown');
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paperWidthFalse: classes.root, scrollPaper: classes.scrollPaper }}
      {...rest}
    >
      {title ? (
        <DialogTitle>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <LargeTitle className="text-transform-capitalize">{title}</LargeTitle>
            <IconButton icon={faTimes} className={classes.alignRight} onClick={closeModal} />
          </div>
        </DialogTitle>
      ) : null}
      {children}
    </Dialog>
  );
};
